import { getField } from './dom';

export interface ValidationI18n {
	firstNameRequired: string;
	lastNameRequired: string;
	emailRequired: string;
	emailInvalid: string;
}

export function validateGuest(
	i18n: ValidationI18n,
): Record<string, string> {
	const errors: Record<string, string> = {};

	const firstName = getField('first_name');
	const lastName = getField('last_name');
	const email = getField('email');

	if (!firstName?.value.trim()) {
		errors.first_name = i18n.firstNameRequired;
	}

	if (!lastName?.value.trim()) {
		errors.last_name = i18n.lastNameRequired;
	}

	if (!email?.value.trim()) {
		errors.email = i18n.emailRequired;
	} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
		errors.email = i18n.emailInvalid;
	}

	return errors;
}
